import axios from 'axios'

import { useApi } from '@/composables/useApi'

const api = useApi()

export class VslService {
     static serverURL = `${process.env.VUE_APP_HOST_API_BACKEND || "/api/dkbackend"}`;

     static getALLVsls() {
       const dataURL = `${this.serverURL}/vsls`
       return axios.get(dataURL)
     }

     static getVsl(vslId) {
       const dataURL = `${this.serverURL}/vsl/${vslId}`

       return axios.get(dataURL)
     }

     static deleteVsl(vslId) {
       const dataURL = `${this.serverURL}/vsl/${vslId}`
       return axios.delete(dataURL)
     }
}

export function Vsl_Service() {
  this.getVslId = function (id_vsl) {
    return new Promise((resolve, reject) => {
      try {
        api.get(`/vsl/${id_vsl}`)
          .then(resp => {
            resolve(resp.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}
